import calculateMD5 from "utils/fileUtils/calculateMD5";
import mapFileToFileRequest, {
  MapFileToFileRequestProps,
} from "./mapFileToFileRequest";

export default async function mapFileToAttachmentFileList({
  fileType,
  file,
  fileHash,
  allowedExtensions,
}: MapFileToFileRequestProps) {
  if (!!file) {
    const md5Hash = fileHash || (await calculateMD5(file));

    const attachmentFileRequest = await mapFileToFileRequest({
      fileType,
      file,
      fileHash: md5Hash,
      allowedExtensions,
    });

    return attachmentFileRequest;
  }

  return;
}
